import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getMobileFontSizeClassName } from './get-mobile-font-size-class-name';
import { extractValuesFromHtml } from './html';
var fontSizeExtractor = function ($) {
    return ['span', 'ul', 'li', 'p', 'h1', 'h2', 'h3', 'div']
        .map(function (e) {
        return $(e)
            .map(function (_id, el) { return $(el).css('font-size'); })
            .get()
            .map(toMobileFontSize);
    })
        .reduce(function (acc, curr) { return acc.concat(curr); }, []);
};
export var getMobileFontSizeClasses = function (htmls, _props) {
    return extractValuesFromHtml(htmls, fontSizeExtractor)
        .map(function (fontSize) {
        return "." + getMobileFontSizeClassName(fontSize) + "{font-size: " + fontSize + "px !important;}";
    })
        .join(' ');
};
//# sourceMappingURL=get-mobile-font-size-classes.js.map